import { useContext, useEffect, useState } from 'react';
import { truncate } from 'lodash';
import { Box, Flex, Stack, WithIcon } from '../../../shared/layouts';
import Card from '../../../shared/Card';
import ProgressBar from '../../../shared/ProgressBar';
import ConfirmIcon from 'imagesUwKluis/svg/confirmed-filled.svg';
import AlertIcon from 'imagesUwKluis/svg/alertfill.svg';
import WhiteLabelContext from '../../../../context/WhiteLabelContext';
import {useTranslation} from "react-i18next";
import AlertMessageBanner from "../../../shared/AlertMessageBanner";
import Button from "../../../shared/Button";

const DocumentRequestDetailCard = ({
  id,
  name,
  type,
  documents_count,
  setOpenModal,
  isRejected,
  isResolved,
  isMinTablet,
  rejection_reason,
  processing_files_count,
  message
}) => {
  const { t } = useTranslation();
  const baseColor = isResolved ? 'succes' : 'primary';
  const statusColor = isRejected || message ? 'alert' : baseColor;
  const iconSize = isMinTablet ? '2rem' : '1.5rem';
  const { addNameToDocument } = useContext(WhiteLabelContext);
  const truncateLimit = 96;
  const [dots, setDots] = useState('');

  const LoadingDots = () => {
    useEffect(() => {
      const interval = setInterval(() => {
        setDots(prev => (prev.length < 3 ? prev + '.' : '.'));
      }, 300);

      return () => clearInterval(interval);
    }, []);

    return <span>{dots}</span>;
  };

  return (
    <Card
      p="m"
      onClick={() => setOpenModal(id)}
      css={{
        position: 'relative',
        cursor: 'pointer',
        overflow: 'hidden'
    }}
    >
      <Flex width={'100%'} alignItems={'center'} flexWrap={{ mobile: 'wrap', tablet: 'nowrap'}}>
        <WithIcon
          space="m"
          color={statusColor}
          css={{ flexGrow: 1, paddingRight: '8px' }}
        >
          {isResolved && !message && (
            <ConfirmIcon
              width={iconSize}
              height={iconSize}
              css={{ alignSelf: !isMinTablet ? 'flex-start' : null }}
            />
          )}
          {isRejected || message && (
            <AlertIcon
              width={iconSize}
              height={iconSize}
              css={{ alignSelf: !isMinTablet ? 'flex-start' : null }}
            />
          )}
          <Stack space="xs" flexGrow={1}>
            <Box
              fontSize={{ mobile: '14px', tablet: '16px' }}
              fontWeight="bold"
              lineHeight={{ mobile: '16px', tablet: '20px' }}
            >
              {isRejected && (
                <span css={(theme) => ({ color: theme.colors.alert })}>
                  {t('Afgekeurd') + ': '}
                </span>
              )}
              {`${name} ${addNameToDocument && type ? type : ''}`}
            </Box>
            <Flex pr={'56px'} justifyContent="space-between">
              <Box fontSize={{mobile: '10px', tablet: '16px'}}>
                {documents_count === 1
                  ? t('{{count}} bestand', {count: documents_count})
                  : t('{{count}} bestanden', {count: documents_count})}

                {processing_files_count !== 0 && (
                  <>
                    {` (${t('{{count}} in verwerking', {count: processing_files_count})}) `}
                    <LoadingDots />
                  </>
                )}
              </Box>
            </Flex>
          </Stack>
        </WithIcon>
        <Button
          variant={isResolved ? "primary-outline" : "primary"}
          width={!isMinTablet ? '100%' : null}
          css={{ flexShrink: 0, marginTop: !isMinTablet ? '8px' : null }}
        >
          {t('Voeg document(en) toe')}
        </Button>
      </Flex>
      {isRejected && (
        <AlertMessageBanner>
          {t('Reden van afkeuring')}: &nbsp;
          {isMinTablet || rejection_reason.length <= truncateLimit
            ? rejection_reason
            : truncate(rejection_reason, { length: truncateLimit })}
        </AlertMessageBanner>
      )}

      {message && <AlertMessageBanner withIcon={false}>{message}</AlertMessageBanner>}

      <ProgressBar
        value={documents_count}
        total={documents_count || 1}
        color={statusColor}
        css={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          background: 'transparent',
        }}
      />
    </Card>
  );
};

export default DocumentRequestDetailCard;
